export default {
  INSTAGRAM: 'https://instagram.com/flowmetalfab',
}